<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    :return-value.sync="date"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      v-bind:value="formatDate"
      v-bind:label="label"
      append-icon="event"
      readonly
      v-bind:error-messages="errorMessages"
    ></v-text-field>

    <v-date-picker v-model="date" locale="es-ES" scrollable v-bind:min="min" v-bind:max="max">
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancel(date)">{{$t('message.cancel')}}</v-btn>
      <v-btn flat color="primary" @click="save(date)">{{$t('message.ok')}}</v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
export default {
  props: ["label", "value", "min", "max", "errorMessages"],
  data: () => ({
    menu: false,
    date: undefined
    //initValue: value
  }),
  watch: {
    value(value) {
      this.date = value;
      this.$emit("input", value);
    }
  },
  computed: {
    formatDate() {
      // return this.value ? new Date(this.value.getTime() - (this.value.getTimezoneOffset() * 60000)).toISOString().substr(0, 10) : undefined;
      return this.date ? this.date : undefined;
    }
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.$emit("input", date);
    },
    cancel(value) {
      this.date = this.value;
      this.menu = false;
    }
  }
};
</script>

